import { observerEpicHelper } from 'epics/helpers'
import { Actions as AlgoliaDataActions } from 'actions/algolia2/data'
import { algoliaAccountCollectionApi } from 'apis/algolia'
import { Actions as PageActions } from 'actions/page'
import { Actions as ScrollActions } from 'actions/utility/scroll'
import {
  getAlgoliaDataHitsPerPage,
  getAlgoliaDataPaginationCurrent,
  getSelectedFacets,
} from 'selectors/algolia2/data'
import { applicationId, searchApi, searchIndice } from '../helpers/constants'
import { Actions as AppActions, Constants } from '../actions'
import { getUrlStringWithParams } from '../selectors/algolia'
import Selectors from '../selectors'
export const updateHitsPerPageEpic = observerEpicHelper(
  [Constants.UPDATE_HITS_PER_PAGE],
  async ({ action, observer, store }) => {
    const url = getUrlStringWithParams({
      hitsPerPage: action.payload,
      page: '',
    })({ ...store.value })
    observer.next(ScrollActions.SCROLL_TO_TOP())
    observer.next(AppActions.UPDATE_URL(url))
    observer.complete()
  }
)
export const updatePageEpic = observerEpicHelper(
  [Constants.UPDATE_PAGE],
  async ({ action, observer, store }) => {
    const url = getUrlStringWithParams({
      page: action.payload,
    })({ ...store.value })
    observer.next(ScrollActions.SCROLL_TO_TOP())
    observer.next(AppActions.UPDATE_URL(url))
    observer.complete()
  }
)
export const updateAlgoliaEpic = observerEpicHelper(
  [Constants.UPDATE_ALGOLIA],
  async ({ action, observer, store }) => {
    observer.next(PageActions.IS_READY(false))
    // Get Algolia Config Data: applicationId, searchApi, searchIndice
    // Update Sort
    const hitsPerPage = getAlgoliaDataHitsPerPage({ ...store.value })
    const pageNumber = getAlgoliaDataPaginationCurrent({ ...store.value })
    const selectedFacets = getSelectedFacets({ ...store.value })
    const userId = Selectors.getUserId({ ...store.value })
    const filters = `is_publicly_searchable: "${selectedFacets.is_publicly_searchable}"`
    const algoliaParams = {
      applicationId,
      searchApi,
      searchIndice,
      filters,
      hitsPerPage,
      page: pageNumber,
      query: `"${userId}"`,
      restrictSearchableAttributes: 'collection_owner_id',
      typoTolerance: false,
      // Accept override params => `page`, hitsPerPage``
      ...(action.payload ? action.payload : {}),
    }
    const algoliaResults = await algoliaAccountCollectionApi(algoliaParams)
    observer.next(AlgoliaDataActions.SET_DATA({ ...algoliaResults }))
    observer.next(PageActions.IS_READY(true))
    observer.complete()
  }
)
export default [updateHitsPerPageEpic, updatePageEpic, updateAlgoliaEpic]
